@import '~style-sheet-helpers/core.less';

@font-size: 14px;

.bulk-ship-from {
  display: grid;
  grid-template-columns: auto 1fr;
  row-gap: 10px;
  font-size: @font-size;

  > .ship-from-input-label {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
  }
}
